import React from 'react'
import Lottie from 'react-lottie';
import * as location from '../images/loader.json'
import "./preloader.css"

function PreLoader() {

  function onReady(callback) {
    var intervalID = window.setInterval(checkReady, 1000);

    function checkReady() {
        if (document.getElementsByTagName('body')[0] !== undefined) {
            window.clearInterval(intervalID);
            callback.call(this);
        }
    }
}

  onReady(function () {
    setTimeout(() => {
      document.querySelector('.loader').style.opacity = '0';
    }, 3000);
    setTimeout(() => {
      document.querySelector('.loader').style.display = 'none';
    }, 5000);
    
  });

    const defaultOptions = {
        loop: true,
      autoplay: true, 
      animationData: location.default,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    }

    return (
        <div className="loader">
          <h1 className="titre">Com'inboard</h1>
          <Lottie options={defaultOptions}
            height={400}
            width={400} />
        </div>
    )
}

export default PreLoader
